export enum PaymentStages {
    INVOICE_DETAILS,
    PAYMENT_DETAILS,
    CARD_PAYMENT_COMPLETE,
    BACS_PAYMENT_COMPLETE,
    PAYMENT_FAILURE
}
